import {createAction, props} from '@ngrx/store';

export const setAPIConfig = createAction('[Storage] set api config', props<{ config: string}>());

export const setAPIEndpoint = createAction('[Storage] set api endpoint', props<{ endpoint: 'account' | 'admin' | 'productDB'}>());
export const setInjectionToken = createAction('[Storage] set injection token', props<{ token:string,  expiredIn: number}>());

export const setAccessExpire = createAction('[Storage] set access expire', props<{ expiredIn: number}>());
export const setRefreshExpire = createAction('[Storage] set refresh expire', props<{ expiredIn: number}>());

export const deleteTokens = createAction('[Storage] delete tokens');
export const setEntryPoint = createAction('[Storage] set entry point', props<{ entryPoint: null | string}>());
export const setScopes = createAction('[Storage] set ui scopes', props<{ scopes: null | string[]}>());

export const userId = createAction('[Storage] userId', props<{ userId: null | string}>());

export const setListConfig = createAction('[Global] setListConfig', props<{ id: string, visibleColumnFields: string[] }>());
